import React from 'react';

import DownstreamTable from '../../../../../components/Table/DownstreamTable';

const DownStream: React.FC<{
  selectedYear: string;
  facilityId: string;
}> = ({selectedYear, facilityId}) => {
  return (
    <DownstreamTable selectedYear={selectedYear} facilityId={facilityId} />
  );
};

export default DownStream;
